import styled from 'styled-components';

export const TabsContainer = styled.div`
    display: grid;
    justify-items: center;
`;
